<template>
  <div ref="footer" class="md:flex mt-14 px-4 py-6 md:px-10 lg:px-12 md:py-14 bg-black text-white pr-header">
    <div v-if="about" class="md:w-2/5 xl:w-1/2 uppercase text-lg xl:text-2xl break-words">
      <div class="md:mr-12">
        <div v-text="about.address" />

        <ul class="mt-12">
          <li>{{ $t('footer', 'tel') }}</li>
          <li>{{ $t('footer', 'fax') }}</li>
          <li class="mb-12"><a href="mailto:contact@timesmuseum.org">contact@timesmuseum.org</a></li>
          <li v-for="(item, count) in about.social" :key="count">
            <a :href="item.url">{{ item.platform }}</a>
          </li>
        </ul>

        <!-- TODO: connect to a field, bilingual -->
        <div class="mt-12" v-html="$t('footer', 'copy')"></div>
        <div v-html="$t('footer', 'rights')" />
      </div>
      <div v-if="isChinese" class="my-12">粤ICP备13004814号-1</div>
      <img class="w-32 mt-12" :src="require('../assets/timesmuseum_qrcode.jpg')" />
    </div>
    <div v-if="about" class="md:w-3/5 xl:w-1/2 text-xl md:text-lg xl:text-2xl">
      <div v-html="about.footer" class="hidden md:block whitespace-pre-line" />

      <router-link :to="localeLink('/about')" class="mt-6 block">
        <span class="hidden md:block">{{ $t('footer', 'more') }}</span>
        <span class="block md:hidden">{{ $t('footer', 'about') }}</span>
      </router-link>
    </div>
  </div>
</template>

<script>
import store from '@/store'

export default {
  name: 'Footer',
  computed: {
    about () {
      return this.localeItem(store.state.about)
    },
    isChinese () {
      return this.$store.state.locale === 'cn'
    }
  },

  mounted () {
    store.dispatch('getAbout')

    // let observer = new IntersectionObserver((entries, obs) => {
    //   entries.forEach(entry => {
    //     if(entry.intersectionRatio!=1){
    //       console.log('A', obs)
    //     }
    //     else if(isPaused) {
    //       console.log('B', obs)
    //     }
    //   });
    // }, {threshold: 1})
    // observer.observe(this.$refs.footer)
  }
}
</script>

<style lang="stylus" scoped>
  p
    margin-bottom: 1em
</style>
